import {namespace} from './common/Utils';
import DarkMode from './darkMode/DarkMode';

class App {
	constructor({ useBtnToggle = true, useCookie = true } = {}) {
    if( DarkMode.isUsingDarkMode){ // (window._isDarkmode === 'true' || window._isDarkmode === true) && (!!window.matchMedia);
      namespace('ncDarkmode');
      window.ncDarkmode = new DarkMode({ useBtnToggle, useCookie });

      // 레거시, lineage2m 라이브 배포 이후에는 삭제 해야함 (1027 배포버전 기준)
      namespace('ncrwd.darkmode'); // (window._isDarkmode === 'true' || window._isDarkmode === true) && (!!window.matchMedia);
      ncrwd.darkmode = window.ncDarkmode;
    }

	}
}

namespace('_ui.darkmode');
window._ui.darkmode = App;

console.log('ui.darkmode loaded');
